import { WebCustomerContact } from ".";

export interface WebCustomer
{
    CustId: string;
    BranchCustId: string;
    BranchNo: string;
    Name: string;
    AcctNo: number;
    Addr1: string;
    Addr2: string;
    City: string;
    State: string;
    Zip: string;
    CreditLimit: number;
    ApsSourceNo: number;
    Contacts: WebCustomerContact[];
}

export const emptyCustomer = {
    CustId: "SMIMA1",
    BranchNo: "34",
    BranchCustId: "A000SMIMA1",
    Name: "Mark & Jane Smith",
    AcctNo: 57,
    Addr1: "80548 380th St",
    Addr2: "",
    City: "Bird Island",
    State: "MN",
    Zip: "55310",
    CreditLimit: 1234,
    ApsSourceNo: 22,
    Contacts: [
        {
            Name: "Mark Smith",
            Phone: "3203826208",
            Email: "mjsmith@tds.net"
        },
        {
            Name: "",
            Phone: "3203826209",
            Email: "mjsmith@tds.net"
        }
    ]
};
export const webCustomerDefault = emptyCustomer;// null;
